import React from 'react';
import { Link } from 'react-router-dom';
import ServiceHighlight from '../components/ServiceHighlight';

const ServicesPage: React.FC = () => {
  const services = [
    {
      title: 'Pressure Washing Driveways and Patios',
      description: 'Our professional pressure washing service removes years of dirt, grime, algae, and weeds from your driveways and patios, restoring them to their original appearance. We use specialized equipment and techniques to ensure a thorough clean without damaging the surface.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/pressure-washing.png'
    },
    {
      title: 'Gutter Clearing/Cleaning',
      description: 'Blocked gutters can cause serious damage to your property. Our gutter clearing service removes leaves, debris, and blockages to ensure proper water flow and protect your property from water damage. We also clean the exterior of your gutters to improve appearance.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/gutter-clearing.png'
    },
    {
      title: 'Roof Cleaning',
      description: 'Our roof cleaning service removes moss, lichen, and algae that can damage your roof and reduce its lifespan. We use gentle cleaning methods that remove harmful growth without damaging your roof tiles or shingles.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/roof-cleaning.png'
    },
    {
      title: 'Commercial Exterior Cleaning',
      description: 'Professional jet washing for business exteriors, including storefronts, parking lots, and walls, to enhance your property\'s curb appeal.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/commercial-exterior.jpeg'
    },
    {
      title: 'Gutter, Soffit and Fascia',
      description: 'Comprehensive cleaning of gutters, soffits, and fascias to remove debris and stains, ensuring your property looks pristine and functions properly.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/gutter-soffit-fascia.png'
    },
    {
      title: 'Stone Wall Cleaning and Treatment',
      description: 'Specialized jet washing and treatment for stone walls, removing dirt and algae while protecting the surface for long-lasting results.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/stone-wall.png'
    },
    {
      title: 'And More...',
      description: 'We offer a range of additional property cleaning and maintenance services including decking cleaning, fence cleaning, commercial pressure washing, and more. Contact us to discuss your specific requirements and how we can help maintain the appearance and value of your property.',
      image: 'https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/services/additional-services.png'
    }
  ];

  return (
    <>
      <div className="pt-32 pb-16 bg-black">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold text-gold text-center mb-8">Our Services</h1>
          <p className="text-white text-center text-xl max-w-3xl mx-auto">
            Professional property cleaning services delivered with care and attention to detail
          </p>
        </div>
      </div>
      
      <section className="py-16 bg-black-light">
        <div className="container-custom">
          <div className="space-y-24">
            {services.map((service, index) => (
              <ServiceHighlight
                key={index}
                title={service.title}
                description={service.description}
                image={service.image}
                isReversed={index % 2 !== 0}
              />
            ))}
          </div>
          
          <div className="mt-24 text-center">
            <h3 className="section-title">Need a Customized Service?</h3>
            <p className="text-white mb-8 max-w-3xl mx-auto">
              We understand that every property is unique. Contact us to discuss your specific requirements and get a personalized quote.
            </p>
            <Link to="/contact" className="btn-primary inline-block">
              Get a Quote
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesPage;